import React, { useEffect, useState } from 'react';

interface IdleTimeoutModalProps {
  onStay: () => void;
  onLogout: () => void;
  promptTime: number;
}

const IdleTimeoutModal: React.FC<IdleTimeoutModalProps> = ({ onStay, onLogout, promptTime }) => {
  const [countdown, setCountdown] = useState(promptTime);

  useEffect(() => {
    if (countdown <= 0) {
      return;
    }
    const timer = setInterval(() => {
      setCountdown(prev => prev - 1);
    }, 1000);
    return () => clearInterval(timer);
  }, [countdown]);

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
      <div className="bg-white rounded-lg p-8 shadow-2xl text-center">
        <h2 className="text-2xl font-bold mb-4 text-gray-900">Are you still there?</h2>
        <p className="mb-6 text-gray-800">You will be logged out due to inactivity in {countdown} seconds.</p>
        <div className="flex justify-center space-x-4">
          <button
            onClick={onStay}
            className="bg-blue-500 hover:bg-blue-600 text-white font-bold py-2 px-6 rounded-lg transition-colors"
          >
            Stay Logged In
          </button>
          <button
            onClick={onLogout}
            className="bg-gray-300 hover:bg-gray-400 text-gray-800 font-bold py-2 px-6 rounded-lg transition-colors"
          >
            Log Out
          </button>
        </div>
      </div>
    </div>
  );
};

export default IdleTimeoutModal;
